import { TableCell, Stack } from "@mui/material";

const PrescriptionSubmittedCellHeader = () => {
  return (
    <TableCell width="9%">
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
        }}
      >
        Rx Submitted
      </Stack>
    </TableCell>
  );
};
export default PrescriptionSubmittedCellHeader;
